import { PLATFORM_SELF_SERVE_API, adminSelfServeSignupListSchema, adminSelfServeSignupSchema, selfServeCheckoutSchema, selfServeEstimateSchema, selfServeSettingsSchema, selfServeSignupSchema, selfServeStatusSchema, } from '@traceio-org/platform-contracts';
/** Route templates for error reports (PLATFORM_SELF_SERVE_API builds the paths). */
const ROUTES = {
    adminSignups: PLATFORM_SELF_SERVE_API.adminSignups,
    adminSettings: PLATFORM_SELF_SERVE_API.adminSettings,
    adminRetrySignup: '/v1/admin/billing/self-serve-signups/:signupId/retry',
    signup: '/v1/self-serve/signups/:signupId',
};
/** Which route and verb each method serves, so a test holds the client to the contract's route table. */
export const SELF_SERVE_CLIENT_METHODS = {
    adminSelfServeSignups: { method: 'GET', route: 'adminSignups' },
    adminRetrySelfServeSignup: { method: 'POST', route: 'adminRetrySignup' },
    adminSelfServeSettings: { method: 'GET', route: 'adminSettings' },
    adminUpdateSelfServeSettings: { method: 'PUT', route: 'adminSettings' },
    selfServeStatus: { method: 'GET', route: 'status' },
    selfServeEstimate: { method: 'POST', route: 'estimate' },
    createSelfServeSignup: { method: 'POST', route: 'signups' },
    currentSelfServeSignup: { method: 'GET', route: 'currentSignup' },
    selfServeSignup: { method: 'GET', route: 'signup' },
};
export function createSelfServeMethods(request) {
    const withToken = (spec, options) => request({ ...spec, auth: 'bearer', signal: options?.signal, accessToken: options?.accessToken });
    return {
        adminSelfServeSignups: (query, options) => withToken({
            route: ROUTES.adminSignups,
            path: PLATFORM_SELF_SERVE_API.adminSignups,
            method: 'GET',
            query: { state: query?.state, limit: query?.limit },
            schema: adminSelfServeSignupListSchema,
        }, options),
        adminRetrySelfServeSignup: (signupId, body, options) => withToken({
            route: ROUTES.adminRetrySignup,
            path: PLATFORM_SELF_SERVE_API.adminRetrySignup(signupId),
            method: 'POST',
            body,
            schema: adminSelfServeSignupSchema,
        }, options),
        // The switch's staff methods: the admin-audience token of the call (RequestOptions.accessToken) or getAccessToken.
        adminSelfServeSettings: (options) => withToken({
            route: ROUTES.adminSettings,
            path: PLATFORM_SELF_SERVE_API.adminSettings,
            method: 'GET',
            schema: selfServeSettingsSchema,
        }, options),
        adminUpdateSelfServeSettings: (body, options) => withToken({
            route: ROUTES.adminSettings,
            path: PLATFORM_SELF_SERVE_API.adminSettings,
            method: 'PUT',
            body,
            schema: selfServeSettingsSchema,
        }, options),
        // The public switch status: no token and no cookies, so the pricing site can read it with nothing signed in.
        selfServeStatus: (options) => request({
            route: PLATFORM_SELF_SERVE_API.status,
            path: PLATFORM_SELF_SERVE_API.status,
            method: 'GET',
            auth: 'none',
            schema: selfServeStatusSchema,
            signal: options?.signal,
        }),
        selfServeEstimate: (body, options) => withToken({
            route: PLATFORM_SELF_SERVE_API.estimate,
            path: PLATFORM_SELF_SERVE_API.estimate,
            method: 'POST',
            body,
            schema: selfServeEstimateSchema,
        }, options),
        createSelfServeSignup: (body, options) => withToken({
            route: PLATFORM_SELF_SERVE_API.signups,
            path: PLATFORM_SELF_SERVE_API.signups,
            method: 'POST',
            body,
            schema: selfServeCheckoutSchema,
        }, options),
        currentSelfServeSignup: (options) => withToken({
            route: PLATFORM_SELF_SERVE_API.currentSignup,
            path: PLATFORM_SELF_SERVE_API.currentSignup,
            method: 'GET',
            schema: selfServeSignupSchema,
        }, options),
        selfServeSignup: (signupId, options) => withToken({
            route: ROUTES.signup,
            path: PLATFORM_SELF_SERVE_API.signup(signupId),
            method: 'GET',
            schema: selfServeSignupSchema,
        }, options),
    };
}
//# sourceMappingURL=self-serve.js.map